import { Alert, Skeleton } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import gql from 'graphql-tag';
import { useAuthedQuery } from 'utils/qlAuth';

export const UniverseLeonardoFramesAutomation = (props: { universeId: number }) => {
  const qFrames = useAuthedQuery(
    gql`
      query UniverseController_getLeonardoFramesAutomation($universeId: Int!) {
        UniverseController_getLeonardoFramesAutomation(universeId: $universeId)
      }
    `,
    {
      variables: { universeId: Number(props.universeId) },
    },
  );

  if (qFrames.error) {
    return <div>error</div>;
  }
  if (qFrames.loading) {
    return <Skeleton active />;
  }

  const jsonString = qFrames.data?.UniverseController_getLeonardoFramesAutomation;
  return (
    <>
      <Alert
        message="Leonardo.AI Image generation automation"
        description="Script for UI.Vision extension to automate images creation with Leonardo.AI. Copy this script to UI.Vision and run it to create images."
        type="info"
        showIcon
        style={{ marginBottom: '16px' }}
      />
      <TextArea rows={30} value={jsonString} />
    </>
  );
};
